'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$7$$anon$17(evaluator$26) {
  this.LM = null;
  this.LM = evaluator$26;
}
export { $c_Lsamples_Persons$package$$anon$7$$anon$17 as $c_Lsamples_Persons$package$$anon$7$$anon$17 };
$p = $c_Lsamples_Persons$package$$anon$7$$anon$17.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$7$$anon$17;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$7$$anon$17() {
}
export { $h_Lsamples_Persons$package$$anon$7$$anon$17 as $h_Lsamples_Persons$package$$anon$7$$anon$17 };
$h_Lsamples_Persons$package$$anon$7$$anon$17.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LM.h();
  return (((typeof v) === "number") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$7$$anon$17 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$7$$anon$17, "samples.Persons$package$$anon$7$$anon$17", ({
  q5: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$7$$anon$17 as $d_Lsamples_Persons$package$$anon$7$$anon$17 };
